import config from '../../../../config/config';
import { Configuration, ProjectMilestonesApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const projMilestonesApi = new ProjectMilestonesApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
